module.exports = __webpack_public_path__ + "img/recommed-img2.49105d74.jpg";